/* Copyright 2017 Asylum Entertainment @bentbot */
import { Router, RouterLink, RoutesRecognized,  ActivatedRoute, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { fade, slowfade, show, menu, menuItem, secondarymenuItem, menuUser, menuLogo, login, submenu, submenucaret, menuBars, mainMenu, loadingPostion, largesubmenu, usersubmenu, optionsMenu, submenuchoice, logostate, marker,bottommarker, bottombar, searchMenu, line1, line2, line3, secondarymenuright, secondarymenuleft, searchResults, highlight, leftmenu, rightmenu, leftmenuitem, rightmenuitem, menuSubItem, mobilemenu, RightLogin, centreMenu, centreMenuPrompt, centreMenuLogin, centreMenuCreate } from './app.animations';
import { ChangeDetectorRef, Injectable, Inject, ViewChild, ElementRef, HostListener, Component, Input, trigger, state, animate, style, transition, keyframes } from '@angular/core';
import { Title, DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Http, Response, Headers, ConnectionBackend, RequestOptions, Request, RequestOptionsArgs } from '@angular/http';
import { HttpInterceptorService } from "ng2-http-interceptor";
import { LoadingBarService } from 'id-loading-bar';

import { CookieService } from 'ngx-cookie';
import { Observable } from "rxjs/Rx";
import { Product } from "./models/product";
import { Item } from "./models/item";
import { Angulartics2 } from 'angulartics2';

import { StoreService } from './services/store.service';
import { UserService } from './services/user.service';
import { environment } from './environment';

import { Account } from './models/account';
import { Currency } from './models/currency';
import { Login } from './models/login.constructor';

declare var $: any;

/**  
  * IDENTITY
  * 
  * Asylum Entertainment
  * * * * * * *
  * app.component
  * Global Applicaiton Frame
  * * * * * * * 
  * Handles the header and footer page elements
  * Loads the background and page contianer
  * Loads globally on every page
  * Passes router the page conditions
**/ 

@Component({  
  selector: 'app-root',
  providers: [
    LoadingBarService,
  	StoreService,
    UserService
  ],
  templateUrl: './app.component.html',
  inputs: ['login', 'message'],
  // styles: [':host { opacity: 0 }'],     //   SUPER COOL
  // host: { '[@slowfade]': 'true' },     //   PAGE FADE-IN
  animations: [ fade, slowfade, show, menu, menuItem, menuUser, menuLogo, login, submenu, submenucaret, menuBars, mainMenu, loadingPostion, largesubmenu, usersubmenu, optionsMenu, submenuchoice, logostate, marker, bottommarker, bottombar, searchMenu, line1, line2, line3, secondarymenuItem, secondarymenuright, secondarymenuleft, searchResults, highlight, leftmenu, rightmenu, leftmenuitem, rightmenuitem, menuSubItem, mobilemenu, RightLogin, centreMenu, centreMenuPrompt, centreMenuLogin, centreMenuCreate ]
})
export class AppComponent {
  
  @ViewChild('sitesearch') sitesearch;

  /**
  *  Login account listiner
  **/
  @Input() login: any;
  @Input() message: any;

 
  /* Page Variables */
  unreadNotifications: number;
  showNaviPanel: string;
  headerPosition: any;
  innerWidth: number;
  percentage: number;
  loggedIn: boolean;
  subtitle: string;
  lastTop: number;
  currentYear: any;
  routerLink: any;
  loading: boolean;
  searching: any;
  title: string;
  loader: any;
  header: any;
  last: any;
  notif: any;
  link: any;
  url: any;
  sft: any;

  showAccountSubmenu = false;
  showItemsSubmenu = false;
  showAboutSubmenu = false;
  showOptionsMenu = false;
  showShopSubmenu = false;
  showLoginField = false;
  showusermenu = false;
  bottomSignup = false;
  showMainMenu = true;
  menuScroll = false;
  showNotif = true;
  loaded = false;
  menuOffset = 0;
  menuHood = 0;
  user = 0;

  activetedRoute: string;
  search = 'false';
  scrollState = 'large';
  menuPosition = 'prompt';
  submenuState = 'products';
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' }; 
  
  searchResultsLength: number;
  searchResultsProduct: Product;
  searchResultsAccount: Account;
  searchResultsItem: Item;
  storeProducts: Product;
  accounts: Account;
  storeItems: Item;
  
  loginField = new Login('', '');
  query = new Search('');

	constructor(private http: Http,
              private router: Router,
              private userService: UserService,
              private storeService: StoreService,
              private sanitizer: DomSanitizer,
              private httpInterceptor: HttpInterceptorService,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private cookies: CookieService,
              private loadingBar: LoadingBarService,
              private track: Angulartics2,          
              private cdRef: ChangeDetectorRef ) {   
                this.activatedRoute.params.subscribe(params => {
                  this.activetedRoute = params['id'];
                });

      // this.loadingBar.reset();
      // this.loadingBar.start();

      /* INTERCEPT HTTP REQUESTS 
      httpInterceptor.request().addInterceptor( (data, method) => {
        this.loadingBar.start();
        return data;
      });
   
      httpInterceptor.response().addInterceptor( (res, method) => {
        this.loadingBar.fill();
        return res;
      });*/

      /* SUBSCRIBE TO ROUTER EVENTS */
      router.events.subscribe( (event) => {

        if (event instanceof NavigationStart) {
          // this.loadingBar.reset();
          this.loadingBar.start();
        }

       if (event instanceof NavigationEnd) {

          this.url = this.router.url;

          // this.loadingBar.stop();
          this.loadingBar.fill();
          this.loaded = true;
        }

        if (event instanceof RoutesRecognized) {
          this.track.eventTrack.next({ action: 'Navigation' });
        }

      });

  }


  /* Show Notification in the Header */
  notification(event) {
    this.unreadNotifications = this.unreadNotifications+1;
    this.showNotif = true;
    this.routerLink = event.link;
    this.notif = event.text;
    this.link = event.url;
    setTimeout( () => {
      this.hideNotifications();
    }, 5000);
  }


  hideNotifications() {
    this.showNotif = false;
  }


  /** 
  * Identity Main Menu
  * 
  * Settings to open and close and change the height of the main menu.
  **/

  toggleMainMenu() {
    this.showMainMenu = this.showMainMenu == true ? false : true; 
  }

  enableAboutMenu() {
    if( this.scrollState == 'small' ) {
      this.showAboutSubmenu = true;
      this.showItemsSubmenu = false;
      this.showShopSubmenu = false;
    }
  }

  enableShopMenu() {
    if( this.scrollState == 'small' ) {
      this.showShopSubmenu = true;
      this.showItemsSubmenu = false;
      this.showAboutSubmenu = false;
    }
  }

  enableItemsMenu() {
    if( this.scrollState == 'small' ) {
      this.showItemsSubmenu = true;
      this.showShopSubmenu = false;
      this.showAboutSubmenu = false;
    }
  }

  toggleAboutMenu() {
    this.showAboutSubmenu = this.showAboutSubmenu ? false : true;
    this.showShopSubmenu = false;
  }

  toggleShopMenu() {
    this.showShopSubmenu = this.showShopSubmenu ? false : true;
    this.showAboutSubmenu = false;
  }

  toggleItemsMenu() {
    this.showItemsSubmenu = this.showItemsSubmenu ? false : true;
    this.showAboutSubmenu = false;
  }

  hideMenus() {
    this.showShopSubmenu = false;
    this.showItemsSubmenu = false;
    this.showAboutSubmenu = false;
  }

  loopleft() {
    this.menuOffset = this.menuOffset+100;
  }

  loopright() {
    this.menuOffset = this.menuOffset-100;
  }

  stoploop() {
    this.menuScroll = false;
  }


  /**
  * Identity Search Feature
  **/

  doSearch(e) {
    this.userService.search(this.query.search)
      .subscribe(results => {
        this.searchResultsItem = results[0];
        this.searchResultsProduct = results[1];
        this.searchResultsAccount = results[2];
        this.searchResultsLength = results.length;
      });

      this.searching = true;
      if ( !this.query.search )
        this.searching = false;
  }

  toggleSearch() {
    
    if ( this.search == 'true' ) {
      this.eventScroll();
      this.searching = 'false';
      this.search =  'false';
    } else {
      this.scrollState = 'large';
      this.searching = 'true';
      this.search =  'true';
    }

    this.sitesearch.nativeElement.focus();

  }

  selectAccount(account) {
    this.accounts = account;
  }


  logMeIn() {
    this.userService.login(this.loginField.username, this.loginField.password)
      .subscribe(result => {
        if (result === true) {
          this.loggedIn = true;
          this.userService.authorizeUser();
          location.reload();
        } else {
          this.loggedIn = false;
        }
      });
  }


  loginKey(e) {
    if ( e.keyCode == 13 )
      this.logMeIn();
    if ( e.keyCode == 17 )
      this.sft = true;
  }


  /**
  * On with the show 
  **/

  ngOnInit() {

    this.user = this.user + 1;

    this.currentYear = (new Date()).getFullYear();

    Promise.resolve(this.storeService.loadProducts()).then( (products) => {
      this.storeProducts = products
    });

    Promise.resolve(this.storeService.getItems()).then( (items) => {
      this.storeItems = items
    });

    // Set page title
    this.titleService.setTitle('Identity');
    
    this.userService.authorizeUser().subscribe( (account) => {
       this.accounts = account;
    });

    // Get the title from the child component
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data)
      .subscribe((event) => this.titleService.setTitle(event['title']))

      // Scroll to top
      this.router.events.subscribe((evt) => {
          if ( !(evt instanceof NavigationEnd) ) { return; }
          window.scrollTo(0, 0)
      });

      this.loggedIn = true;

  }

  menuReset() {
      if (this.innerWidth < 768) {
        this.searching = 'false';
        this.search =  'false';
      }
      this.hideMenus();
  }

  /** 
   * Send the scroll bar to the bottom
  **/
  toBottom() { 
    this.bottomSignup = true;
    window.scrollTo(0,0); 
  }


  /**
  * Post-Load Javascript carriage
  **/

  ngAfterViewInit() {

    // this.loadingBar.start();
    
    /// Enable paralax scrolling through megamenu items
    $('.megamenu .image').mousemove(function(e) {
      if (window.innerWidth > 768) {
        var x = -(e.pageX + this.offsetLeft) / 200;
        var y = -(e.pageY + this.offsetTop) / 200;
        //$(this).css('transform','translateY('+ y + '%) translateX('+ x + '%)');
      }
    });

  
   $('body').mousemove( function(e) {
      $('.megamenu-static').each(function(i) {
        // Find the width of all menu elements
        var totalWidth = 0;
        $(this).find('li').each(function(i) {
          totalWidth += $(this).outerWidth();
        });

        // Find the cursor ratio and position the menu
        var l = (window.innerWidth - totalWidth) * e.pageX / (window.innerWidth-75);
        if (window.innerWidth > 768 && window.innerWidth < totalWidth)
          $(this).find('li').css('transform','translateX('+ l + 'px)');
    
      });
    });

    // Scroll listener
    this.menuReset();

    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      this.menuReset();
      if ( this.search != 'true' ) this.eventScroll();
    }, false);

    if ( this.search != 'true' ) this.eventScroll();
    this.userService.authorizeUser();

    this.cdRef.detectChanges();
  }

  /* Scroll Listener */
  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(event: Event): void {
    if ( this.search != 'true' ) this.eventScroll();
    if ( this.menuHood > 0 ) this.menuHood = (25-window.pageYOffset)>0 ? 25-window.pageYOffset : 0;
  }
  

  eventScroll() {

    // this.menuReset();
    // Hide and show the menu when scrolling up / down
    if ( window.pageYOffset > this.last || this.searching != true)
      if (this.innerWidth < 768) this.scrollState = 'hidden';

    if ( window.pageYOffset < this.last )
      if (this.innerWidth < 768) this.scrollState = 'true';

    if ( window.pageYOffset < 10 )
      this.scrollState = 'true';

    if ( window.innerWidth > 768 ) {
      this.showMainMenu = true;
      if ( window.pageYOffset < 30 ) {
        this.scrollState = 'large';
      } else {
        this.scrollState = 'small';
      }
    } else {
      this.showMainMenu = false;
      this.scrollState = 'large';
    }
    this.last = window.pageYOffset;
  }





  /** 
  * Trigger when Page Closed
  * Stop heavy anims & unload page
  **/
  ngOnDestroy() {
    
  }



}

 /** 
  * Models for page input
 **/
export class Search {
  constructor(
    public search?: string
  ) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/app.component.ts